import { Close } from '@mui/icons-material';
import { DialogActions, IconButton, Tooltip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

type CockpitDialogActionsProps = {
  children?: ReactNode;
  onClose: () => void;
  closeLabel: string;
  closeTestId: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

/** Shared action row; close always calls the dialog's existing cancel logic. */
export function CockpitDialogActions({
  children,
  onClose,
  closeLabel,
  closeTestId,
  disabled = false,
  sx
}: CockpitDialogActionsProps) {
  return (
    <DialogActions sx={{ justifyContent: 'flex-end', gap: 1, ...sx }}>
      {children}
      <Tooltip title={closeLabel}>
        <span>
          <IconButton
            data-testid={closeTestId}
            aria-label={closeLabel}
            onClick={onClose}
            disabled={disabled}
            sx={{
              width: 36,
              height: 36,
              minWidth: 36,
              minHeight: 36,
              border: '1px solid var(--cockpit-border)',
              borderRadius: '50%',
              color: 'var(--cockpit-text)',
              '&:hover': {
                color: 'var(--cockpit-accent-contrast)',
                background: 'var(--cockpit-accent)',
                borderColor: 'var(--cockpit-accent)'
              }
            }}
          >
            <Close />
          </IconButton>
        </span>
      </Tooltip>
    </DialogActions>
  );
}
